/**
 * Запрашивает у пользователя разрешение на отображение уведомлений
 *
 * !Выбрасывает ошибку, если разрешение не выдано
 *
 * @returns Успешный результат запроса разрешения на отображение уведомлений
 */
export async function requestNotificationPermission() {
	const result = await new Promise<NotificationPermission>(function (resolve, reject) {
		const permissionResult = Notification.requestPermission(function (result) {
			resolve(result);
		});

		if (permissionResult !== undefined) {
			permissionResult.then(resolve, reject);
		}
	});
	if (result !== "granted") {
		throw new Error("[PUSH] Notification permission was not granted");
	}
	return result;
}
